import React, { useEffect } from "react";
import {
  Form,
  Input,
  Select,
  DatePicker,
  Button,
  Row,
  Col,
  Space,
  Drawer,
} from "antd";
import { CloseCircleOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { saveLeadCallAPI, editLeadCallAPI } from "../LeadsAPI";
import { resetLeadCallById } from "../LeadsSlice";
import { useParams } from "react-router-dom";

const { TextArea } = Input;

const LeadCallForm = (props) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { leadId } = useParams();
  const intl = useIntl();
  const statusList = useSelector((state) => state.lookup.statusList);
  const selectedLanguage = localStorage.getItem("selectedlanguage") || "fr-FR";
  const createdDate = Form.useWatch("createdDate", form);
  useEffect(() => {
    if (props?.initialValues) {
      form.setFieldsValue({
        ...props?.initialValues,
        followUpDate: props?.initialValues.followUpDate
          ? dayjs(props?.initialValues.followUpDate)
          : null,
        createdDate: dayjs(props?.initialValues.createdDate),
      });
    } else {
      form.setFieldsValue({ createdDate: dayjs() });
    }
  }, [props?.initialValues, form]);
  const handleSubmit = (values) => {
    const payload = {
      id: props?.call?.id || 0,
      leadId: leadId,
      createdDate: values.createdDate,
      callStatusId: values.callStatusId,
      followUpDate: values.followUpDate
        ? dayjs(values.followUpDate).format("YYYY-MM-DD")
        : null,
      note: values.note,
    };
    const action = props?.call?.id ? editLeadCallAPI : saveLeadCallAPI;
    dispatch(action(payload, leadId)).then(() => {
      form.resetFields();
      dispatch(resetLeadCallById());
      props?.onClose();
    });
  };

  return (
    <Drawer
      title={
        props?.call ? (
          <FormattedMessage id="AddLeadCall.EditCallLog" />
        ) : (
          <FormattedMessage id="AddLeadCall.CreateCallLog" />
        )
      }
      open={props?.drawerVisible}
      onClose={props?.onClose}
      width={500}
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit} size="large">
        <Form.Item
          label={<FormattedMessage id="AddLeadCall.ContactedDate" />}
          name="createdDate"
        >
          <DatePicker style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          label={<FormattedMessage id="AddLeadCall.CallStatus" />}
          name="callStatusId"
          rules={[
            {
              required: true,
              message: intl.formatMessage({
                id: "AddLeadCall.Error.CallStatus",
              }),
            },
          ]}
        >
          <Select
            placeholder={intl.formatMessage({
              id: "AddLeadCall.Placeholder.SelectStatus",
            })}
          >
            {statusList
              ?.filter((s) => s.id > 7)
              .map((status) => (
                <Select.Option key={status.id} value={status.id}>
                  {status[`name${selectedLanguage === "fr-FR" ? "Fr" : "En"}`]}
                </Select.Option>
              ))}
          </Select>
        </Form.Item>

        <Form.Item
          label={<FormattedMessage id="AddLeadCall.FollowUp" />}
          name="followUpDate"
        >
          <DatePicker
            disabledDate={(current) => {
              if (!createdDate) return false;
              return (
                current && current.isBefore(dayjs(createdDate).startOf("day"))
              );
            }}
            style={{ width: "100%" }}
          />
        </Form.Item>

        <Form.Item
          label={<FormattedMessage id="AddLeadCall.Note" />}
          name="note"
        >
          <TextArea
            rows={4}
            maxLength={255}
            showCount
            placeholder={intl.formatMessage({
              id: "AddLeadCall.Placeholder.EnterNotes",
            })}
          />
        </Form.Item>

        <Row justify="center" className="mt-10">
          <Space>
            <Button danger onClick={props?.onClose}>
              <CloseCircleOutlined />
              <FormattedMessage id="Common.Cancel" />
            </Button>
            <Button type="primary" htmlType="submit">
              <CheckCircleOutlined />
              <FormattedMessage id="Common.Save" />
            </Button>
          </Space>
        </Row>
      </Form>
    </Drawer>
  );
};

export default LeadCallForm;
